import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { EmployeeStatusesService } from '../employee-statuses.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-employee-work-interval',
  templateUrl: './employee-work-interval.component.html',
  styleUrls: ['./employee-work-interval.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EmployeeWorkIntervalComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() workInterval;
  @Input() employeeId;
  @Input() workday;

  moment = require('moment');

  private destroy$ = new Subject<void>();

  constructor(
    private elementRef: ElementRef,
    private employeeStatusesService: EmployeeStatusesService
  ) {}

  ngOnInit() {
    this.employeeStatusesService.isAddData
      .pipe(takeUntil(this.destroy$)).subscribe((state: boolean) => {
        if (state) {
          this.setPosition();
        }
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setPosition();
    }, 0);
  }

  setPosition() {
    if (!this.workInterval) {
      return;
    }

    let hoursStart = +this.moment(this.workInterval.int_begin).format('HH');
    let minutesStart = +this.moment(this.workInterval.int_begin).format('mm');
    let hoursEnd = +this.moment(this.workInterval.int_end).format('HH');
    let minutesEnd = +this.moment(this.workInterval.int_end).format('mm');
    let grandParent = this.elementRef.nativeElement.parentElement.parentElement;

    let childStarts = grandParent.querySelectorAll('div[id="employee_' + this.employeeId +  '_' + this.workday + '_' + hoursStart + '"]');
    let childEnds = grandParent.querySelectorAll('div[id="employee_' + this.employeeId +  '_' + this.workday + '_' + hoursEnd + '"]');

    let childStart = Array.prototype.find.call(childStarts,
      (child) => this.employeeStatusesService.isToday(child, this.workInterval.int_begin));
    let childEnd = Array.prototype.find.call(childEnds,
      (child) => this.employeeStatusesService.isToday(child, this.workInterval.int_end));

    if (childStart && childEnd) {
      setTimeout(() => {
        let s = (childStart.clientWidth / 60) * minutesStart;
        let e = (childEnd.clientWidth / 60) * minutesEnd;
        let w = Math.max(childEnd.offsetLeft + e - (childStart.offsetLeft + s), 1);

          // let workInterval = this.elementRef.nativeElement.querySelector('.work-interval');
          // workInterval.style.left = childStart.offsetLeft + s + 'px';
          // workInterval.style.width = w + 'px';
      }, 4);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
